<template>
  <div class="nav-content">
    <div class="main">
      <div class="logo-contain">
        <img src="@/assets/images/logo.png" class="logo-set">
        <div class="logo-text">
          <p>快点打印</p>
          <small>黑白之间，<span style="color: #f8726b">色彩</span>纷呈~~</small>
        </div>
      </div>
      <div class="nav-list">
        <ul>
          <li>
            <router-link to="/Home" :class="{'a-active':isactive == 0}">首页</router-link>
          </li>
<!--          <li>-->
<!--            <router-link to="/UseHelp" :class="{'a-active':isactive == 1}">使用帮助</router-link>-->
<!--          </li>-->
          <li>
            <router-link to="/News"  :class="{'a-active':isactive == 2}">新闻动态</router-link>
          </li>
          <!--<li>
            <router-link to="/Down" :class="{'a-active':isactive == 3}">客户端下载</router-link>
          </li>-->
          <li>
            <router-link to="/About"  :class="{'a-active':isactive == 4}">快点家族</router-link>
          </li>
          <li>
            <router-link to="/JoinUs"  :class="{'a-active':isactive == 5}">加入我们</router-link>
          </li>
        </ul>
      </div>
      <div class="clear-float"></div>
    </div>
  </div>
</template>
<script>
import * as Api from '../../assets/js/Api'
export default {
  data () {
    return {
      isactive: ''
    }
  },
  created () {
    this.isactive = Api.changeClass
  }
}
</script>
<style>
  .nav-content {
    width: 100%;
    height: 80px;
    box-shadow: 3px 3px 10px -2px rgba(0,0,0,0.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/common/TopHead.vue